// extracted by mini-css-extract-plugin
export var dropdown = "_ul-0";
export var imageWrapper = "_ul-3";
export var itemNameContainer = "_ul-1";
export var productImage = "_ul-2";
export var spinnerWrapper = "_ul-4";